import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { ProcessSection } from './components/ProcessSection';
import { CaseStudiesSection } from './components/CaseStudiesSection';
import { PricingSection } from './components/PricingSection';
import { ResourcesSection } from './components/ResourcesSection';
import { CTABanner } from './components/CTABanner';
import { Footer } from './components/Footer';
import { GoogleTagManager } from './components/GoogleTagManager';
export function App() {
  return <div className="flex flex-col min-h-screen w-full bg-[#f5f5f5]" data-id="element-0">
      <GoogleTagManager gtmId="GTM-PSW3VBL" data-id="element-1" />
      <Header data-id="element-2" />
      <main className="flex-grow" data-id="element-3">
        <HeroSection data-id="element-4" />
        <AboutSection data-id="element-5" />
        <ServicesSection data-id="element-6" />
        <ProcessSection data-id="element-7" />
        <CaseStudiesSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <ResourcesSection data-id="element-10" />
        <CTABanner data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}